<template>
  <OnboardingFeatureView
    ref="elRef"
  >
    <p>
      Ball.app is like Partiful<br>for basketball
    </p>
    <OnboardingRunPreview
      v-model="statusProbability"
      v-model:player="player"
    />
  </OnboardingFeatureView>
</template>

<script setup lang="ts">
import useIntersectionDetection from "@/composables/useIntersectionDetection.ts";
import { TablesInsert } from "@shared/lib/database/database.types.ts";
import delay from "@shared/lib/utils/async/delay.ts";
import { ref, useTemplateRef } from "vue";
import OnboardingFeatureView from "./OnboardingFeatureView.vue";
import OnboardingRunPreview from "./OnboardingRunPreview.vue";

const player = defineModel<TablesInsert<"players">>("player", {
  required: true,
});

const elRef = useTemplateRef<InstanceType<typeof OnboardingFeatureView>>("elRef");
const statusProbability = ref<number | null>(null);

useIntersectionDetection(elRef, async (isIntersecting) => {
  if (isIntersecting) {
    await delay(500);
    statusProbability.value = 1;
  }
});
</script>
